import React from 'react';
import Icon from 'material-ui/svg-icons/navigation/expand-more';

export default class extends React.PureComponent {
  render() {
    return <Icon className="icon expand-more" onClick={this.props.onClick} />;
  }
}
